import * as Yup from "yup";
import { phoneValidation } from "../../utils/phoneValidation";
import { termsAndConditionsValidationSchema } from "../../validation/acceptTermsAndConditions";

export const signupInitialValues = {
  firstName: "",
  lastName: "",
  contactNumber: { countryCode: "", phoneNumber: "" },
  address: {
    city: "",
    state: "",
    country: "",
    street: "",
  },
  userType: "client",
  email: "",
  password: "",
  photo: undefined,
  avatar: "",
  termsAndConditions: false,
};

export const PhoneRegExp =
  /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/gm;

export const signupValidationSchema = Yup.object({
  firstName: Yup.string()
    .min(2, "Must be 2 characters or more")
    .required("Required")
    .trim(),
  lastName: Yup.string()
    .min(2, "Must be 2 characters or more")
    .required("Required")
    .trim(),
  contactNumber: phoneValidation,
  email: Yup.string().email("Invalid email address").required("Required"),

  password: Yup.string()
    .min(6, "Must be 6 characters or more")
    .required("Required"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), undefined],
    "Passwords must match",
  ),
  address: Yup.object({
    country: Yup.string().required("country is required"),
    city: Yup.string().required("city is required"),
    state: Yup.string().required("state is required"),
  }),
  termsAndConditions: termsAndConditionsValidationSchema,
  // photo: Yup.mixed<File>()
  //   .required("photo is required")
  //   .test(
  //     "fileType",
  //     "Unsupported file format",
  //     (value) =>
  //       !value ||
  //       (value instanceof File &&
  //         ["image/jpeg", "image/jpg", "image/png"].includes(value.type))
  //   ),
});
